import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetListGroups = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = DefaultApi({
                params,
                method: 'get',
                url: urls.GET_GROUPS_CASHIERS
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetListGroupsAction({
                    list: data.groups,
                    summ: data.summ
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetListGroups as SetGetListGroups
}